import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "react-bootstrap";

export default function AdminVideoList() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    axios
      .get("/api/admin/videos/active")
      .then((res) => setVideos(res.data || []))
      .catch((err) =>
        console.error("❌ Erreur récupération vidéos actives :", err)
      );
  }, []);

  const handleHide = (videoId) => {
    axios
      .put(`/api/admin/videos/${videoId}/hide`)
      .then(() => {
        setVideos((prev) => prev.filter((v) => v.id !== videoId));
      })
      .catch((err) => console.error("❌ Erreur masquage vidéo :", err));
  };

  return (
    <div className="card mt-4">
      <div className="card-header">Vidéos Actives</div>
      <ul className="list-group list-group-flush">
        {videos.length === 0 ? (
          <li className="list-group-item">Aucune vidéo active</li>
        ) : (
          videos.map((video) => (
            <li key={video.id} className="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <strong>{video.title}</strong> par {video.uploader_pseudo}
              </div>
              <Button
                size="sm"
                variant="danger"
                onClick={() => handleHide(video.id)}
              >
                Masquer
              </Button>
            </li>
          ))
        )}
      </ul>
    </div>
  );
}
